"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var postchain_client_1 = require("postchain-client");
var single_signature_auth_descriptor_1 = require("./single-signature-auth-descriptor");
var AuthDescriptorFactory = /** @class */ (function () {
    function AuthDescriptorFactory() {
    }
    AuthDescriptorFactory.prototype.create = function (type, args) {
        switch (type) {
            case 'S': return this.createSingleSig(args);
        }
    };
    AuthDescriptorFactory.prototype.createSingleSig = function (args) {
        var decodedDescriptor = postchain_client_1.gtv.decodeGtv(args);
        return new single_signature_auth_descriptor_1.default(Buffer.from(decodedDescriptor[1], 'hex'), decodedDescriptor[0]);
    };
    return AuthDescriptorFactory;
}());
exports.default = AuthDescriptorFactory;
//# sourceMappingURL=auth-descriptor-factory.js.map